import React from 'react'
import { Liga } from '../types/liga'

export interface ProfileCardLeagueFollowProps {
  followId: string | null
  loadingSeguir: boolean
  erroSeguir: string
  onSeguir: () => Promise<void>
  showFollowButton: boolean
}

interface ProfileCardLeagueProps {
  liga?: Liga
  /** Estado de seguir vindo do pai; quando passado, card e sidebar ficam sincronizados */
  follow?: ProfileCardLeagueFollowProps
  /** Ao clicar na estatística de torneios, ativa a aba Torneios (ex.: callback do pai ou navegação) */
  onTorneiosClick?: () => void
  /** Ao clicar na estatística de jogadores, ativa a aba Jogadores */
  onJogadoresClick?: () => void
  /** Locais com aluguel vinculados à liga */
  locaisAluguel?: { id: string; nome: string }[]
  /** Callback ao clicar em reservar */
  onReservarClick?: () => void
}

const ProfileCardLeague: React.FC<ProfileCardLeagueProps> = ({ liga, follow, onTorneiosClick, onJogadoresClick, locaisAluguel, onReservarClick }) => {
  if (!liga) {
    return (
      <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3">
        <div className="card-body text-center">
          <p className="mb-0">Liga não encontrada.</p>
        </div>
      </div>
    )
  }

  const showFollow = follow?.showFollowButton ?? false
  const followId = follow?.followId ?? null
  const loading = follow?.loadingSeguir ?? false
  const erro = follow?.erroSeguir ?? ''
  const handleClick = follow?.onSeguir

  return (
    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3 overflow-hidden">
      <div
        id='banner-league'
        className="card-body position-relative h240 bg-image-cover bg-image-center"
        style={{ backgroundImage: `url("${liga?.bannerUrl || '/assets/images/comingsoon.svg'}")` }}
      ></div>
      <div className="card-body d-block pt-4 position-relative">
        <figure className="avatar mt--6 position-relative w75 z-index-1 me-auto">
          <img
            src={liga?.imagemUrl || '/assets/images/user.png'}
            alt={liga?.nome || 'avatar'}
            className="p-1 bg-white rounded-xl w-100"
          />
        </figure>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h4 id='nome-league' className="font-xs ls-1 fw-700 text-grey-900 mb-0">
              {liga?.nome}
              {liga?.username && (
                <span id='tag-league' className="d-block font-xssss fw-500 mt-1 lh-3 text-primary">
                  @{liga.username}
                </span>
              )}
            </h4>
          </div>
          <div className="d-flex flex-column align-items-end ms-3">
            <div className="d-flex align-items-center gap-2">
              {liga?.totalJogadores !== null && liga?.totalJogadores !== undefined && (
                onJogadoresClick ? (
                  <button
                    type="button"
                    className="font-xssss fw-600 text-grey-700 border-0 bg-transparent p-0 text-start text-decoration-underline"
                    style={{ cursor: 'pointer' }}
                    onClick={onJogadoresClick}
                  >
                    {liga.totalJogadores} {liga.totalJogadores === 1 ? 'jogador' : 'jogadores'}
                  </button>
                ) : (
                  <span className="font-xssss fw-600 text-grey-700">
                    {liga.totalJogadores} {liga.totalJogadores === 1 ? 'jogador' : 'jogadores'}
                  </span>
                )
              )}
              {liga?.totalJogadores !== null && liga?.totalJogadores !== undefined && liga?.totalTorneios !== null && liga?.totalTorneios !== undefined && (
                <span className="font-xssss text-grey-500">•</span>
              )}
              {liga?.totalTorneios !== null && liga?.totalTorneios !== undefined && (
                onTorneiosClick ? (
                  <button
                    type="button"
                    className="font-xssss fw-600 text-grey-700 border-0 bg-transparent p-0 text-start text-decoration-underline"
                    style={{ cursor: 'pointer' }}
                    onClick={onTorneiosClick}
                  >
                    {liga.totalTorneios} {liga.totalTorneios === 1 ? 'torneio' : 'torneios'}
                  </button>
                ) : (
                  <span className="font-xssss fw-600 text-grey-700">
                    {liga.totalTorneios} {liga.totalTorneios === 1 ? 'torneio' : 'torneios'}
                  </span>
                )
              )}
            </div>
            {showFollow && handleClick && (
              <button
                onClick={handleClick}
                disabled={loading}
                className={`d-none d-lg-block p-3 z-index-1 rounded-3 font-xsssss text-uppercase fw-700 ls-3 btn mt-2 ${followId ? 'btn-secondary' : 'btn-primary'}`}
              >
                {loading
                  ? 'Aguarde...'
                  : followId
                  ? 'SEGUINDO'
                  : 'SEGUIR'}
              </button>
            )}
          </div>
        </div>
            {(liga?.ramoAtividade || liga?.enderecoCompleto) && (
              <div id="dados-empresa-league" className="mt-2">
                {liga?.ramoAtividade && (
                  <span id="ramo-atividade-league" className="d-block font-xssss fw-500 text-grey-700">
                    <i className="bi bi-briefcase me-1"></i>
                    {liga.ramoAtividade}
                  </span>
                )}
                {liga?.enderecoCompleto && (
                  <span id="endereco-completo-league" className="d-block font-xssss fw-500 text-grey-500">
                    <i className="bi bi-geo-alt me-1"></i>
                    {liga.enderecoCompleto}
                  </span>
                )}
              </div>
            )}
            {erro && follow && (
              <div className="alert alert-danger mt-2" role="alert">
                {erro}
              </div>
            )}
            {locaisAluguel && locaisAluguel.length > 0 && onReservarClick && (
              <div className="d-flex align-items-center gap-3 mt-3 p-3 rounded-xl" style={{ background: '#f0f9ff', border: '1px solid #bae6fd' }}>
                <i className="bi bi-grid-3x3 text-primary" style={{ fontSize: 20 }}></i>
                <div className="flex-grow-1">
                  <span className="font-xssss fw-700 text-grey-900 d-block">Quadras disponíveis para aluguel</span>
                  <span className="font-xssss text-grey-500">
                    {locaisAluguel.length === 1 ? locaisAluguel[0].nome : `${locaisAluguel.length} locais`}
                  </span>
                </div>
                <button
                  className="btn bg-primary-gradiant text-white rounded-xl font-xssss fw-700 px-3 py-2 text-nowrap"
                  onClick={onReservarClick}
                >
                  Reservar agora
                </button>
              </div>
            )}
      </div>
    </div>
  )
}

export default ProfileCardLeague
